import { render, staticRenderFns } from "./ArtworkGallery.vue?vue&type=template&id=400b486c&scoped=true&"
import script from "./ArtworkGallery.vue?vue&type=script&lang=ts&"
export * from "./ArtworkGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ArtworkGallery.vue?vue&type=style&index=0&id=400b486c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b486c",
  null
  
)

export default component.exports